import { RouteParam, RouteParamsWithQueryOverload } from 'ziggy-js'
import { RoutingParams } from '@/Support/Routing/Interfaces/routing'
import { TargetsReorderParams } from '@/Support/Planning/Interfaces/TargetData'

export function routing(
  routeName: string,
  parameters?:
    | RouteParamsWithQueryOverload
    | RouteParam
    | RoutingParams
    | TargetsReorderParams,
): string {
  return route(window.routingPrefix + '.' + routeName, parameters)
}

export const convertToRouteName = (text: string): string =>
  text.replace(/_/g, '-')
